

<ng-template #shareButton>
  <button 
    style="padding: 0 30px !important;" 
    [ngClass]="{ unsharedButton: selectedShareInfo.status === 'unshared', never_shared_share_button:selectedShareInfo.status === 'never shared'  }" mat-button color="primary" [disabled]="processing" (click)="share()">
    <div class="button_content">
      <span class="share-text" [ngClass]="{processing: processing}">Share</span>
      <loader icon="button_wheel" *ngIf="processing"></loader>
    </div>
  </button>
</ng-template>

<top-menu></top-menu>
<mobile-menu></mobile-menu>
<command-menu *ngIf="!!searchTerm || (!!shareList.length && !selectedShareInfo)"
  [filterPage]="filterPage"
  [addItemText]="!event || event.is_readonly ? '' : '+ ADD A TIMELINE'"
  (addItem)="addTimeline()"
></command-menu>
<null-state 
  *ngIf="!!shareList && !shareList.length && !searchTerm && event && !event.closed"
  (buttonClick)="addTimeline()"
  [state]="nullState"
  [title]="nullTitle"
  [hideButton]="!event.can_access"
></null-state>
<div *ngIf="!searchTerm && (!event || event.closed)" class="closed_msg">
  This event is closed. Only active events can be shared.
</div>
<div class="no_results" *ngIf="!!searchTerm && shareList && !shareList.length">There are no timelines that fit your search term.</div>
<joi-message *ngIf="message" [message]="message"></joi-message>
<loader-pane-fragment [trace]="traceNames.viewOnSiteScheduleShare"></loader-pane-fragment>
<nested-table
  *ngIf="!selectedShareInfo && shareList.length"
  [filtersId]="filterPage"
  [items]="shareList"
  [columns]="columnData"
  [columnsById]="columnsById"
  [bigSecondColumn]="true"
  [readOnly]="!event || event.is_readonly"
  [menuItems]="menuItems"
  [dotMenuItems]="dotMenuItems"
  [defaultSelectedColumnId]="defaultColumnId"
  (selectItem)="openShareView($event)"
  (updatedSelectedIds)="selectIds($event)"
></nested-table>
<black-bar-wrapper 
  *ngIf="selectedShareInfo"
  (close)="closeShareView()"
><div class="header">{{ selectedShareInfo.title || event.title }}</div>
  <div *ngIf="event?.closed" class="closed_msg">
    Closed events can't be shared.<br /><br />
    Any shareable URLs for this event have been unpublished.
  </div>
  <div class="share_wrapper" *ngIf="event && !event.closed">
    <div class="share_menu">
      <ng-container *ngIf="selectedShareInfo.status === 'never shared' && event.can_access" [ngTemplateOutlet]="shareButton"></ng-container>
      
      <share-code 
        *ngIf="selectedShareInfo.status !== 'never shared'" 
        [shareType]="shareTypes.oss"
        [hideJson]="true"
        [shareCode]="selectedShareInfo.id" 
        [emailGenerator]="emailGenerator.bind(this)"
        [disabled]="selectedShareInfo.status !== 'shared'"
      >
        <ng-container *ngIf="selectedShareInfo.status === 'unshared'" [ngTemplateOutlet]="shareButton"></ng-container>
      </share-code>
      <div style="flex:1;"></div>
      <div class="shared_status_holder">
        <traffic-light [color]="shareStatusToColor[selectedShareInfo.status]" [text]="shareStatusToText[selectedShareInfo.status]"></traffic-light>
        <div class="unpublish-link" *ngIf="selectedShareInfo.status === 'shared' && event.can_access" (click)="unshare()">Unshare</div>
      </div>
    </div>
    <div class="desktop">
      {{ selectedShareInfo.status === 'shared' ? SHARED_MESSAGE : UNSHARED_MESSAGE }} You can control what is visible by using the <em>Display options</em> and <em>Filter timeline</em> buttons. <span style="font-weight: bold">Note:</span> Changes to the On Site Schedule and Program are updated automatically.
    </div>
    <div class="filters_holder">
      <icon-text *ngIf="!!event.can_access" [active]="!!selectedShareInfo.filters?.count" [text]="'Filter timeline'" (click)="openFilters()"></icon-text>
      <icon-text *ngIf="!!event.can_access" [icon]="null" [text]="'Display options'" (click)="editFields()" [active]="!!selectedShareInfo.excludedFieldIds?.length"></icon-text>
  <!--    STANDARDIZING WITH PROGRAM PUBLISH APPEARANCE     <div  *ngIf="event.can_access" class="filter-link" [ngClass]="{ active: selectedShareInfo.excludedFieldIds?.length }" (click)="editFields()">Display options</div> -->
      <div style="flex:1;"></div>
    </div>
    <scrollable-wrapper [ngClass]="{hideCal:selectedShareInfo.status === 'never shared'}">
      <div class="hint" *ngIf="!timeline?.length">
        You have filtered out all possible programs, sessions, and activities.  Please remove some filters.
      </div>
      <share-timeline 
        *ngIf="timeline?.length"
        [timeline]="timeline" 
        [performers]="performers"
        [eventId]="event.eventId" 
        [shareId]="shareId"
        [labelMaps]="labelMaps"
        [venues]="event.venues"
        [ossShareInfo]="ossShareInfo"
        [madeWithJoi]="madeWithJoi"
        [showActivityStatus]="showActivityStatus"
        [sponsors]="sponsors"
        [performerRoles]="performerRoles"
        [tagMap]="tagMap"
        [sponsorTypes]="sponsorTypes"
        [brandingData]="brandingData"
      >
      </share-timeline>
    </scrollable-wrapper>
  </div>
</black-bar-wrapper>